import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { services } from "@/data/site";
import { Eyebrow, Reveal, fadeUp, staggerContainer } from "../site/motion";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="bg-[#F8FAFC] py-24 md:py-32">
      <div className="mx-auto w-full max-w-[1200px] px-6 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <Reveal className="max-w-xl">
            <Eyebrow>What we do</Eyebrow>
            <h2 className="mt-5 text-3xl font-bold leading-[1.08] tracking-[-0.02em] text-slate-900 md:text-[2.6rem]">
              Technology capabilities built around real business needs.
            </h2>
          </Reveal>
          <Reveal delay={1} className="max-w-md">
            <p className="text-sm leading-relaxed text-slate-600 md:text-base">
              From digital products and custom software to cloud infrastructure and intelligent
              automation, Bytevora helps businesses turn ideas and operational challenges into
              scalable technology solutions.
            </p>
          </Reveal>
        </div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3"
        >
          {services.map((s, i) => (
            <motion.div key={s.slug} variants={fadeUp}>
              <Link
                to={`/services#${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group flex h-full flex-col rounded-[18px] border border-slate-200 bg-white p-7 transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1 hover:border-blue-600/40 hover:shadow-[0_28px_55px_-32px_rgba(37,99,235,0.4)]"
              >
                <div className="flex items-start justify-between">
                  <span className="grid h-11 w-11 place-items-center rounded-xl border border-slate-200 bg-slate-50 text-slate-600 transition-colors duration-300 group-hover:border-blue-600/25 group-hover:text-blue-600">
                    <s.icon size={19} strokeWidth={1.7} />
                  </span>
                  <span className="font-mono text-xs tracking-[0.18em] text-slate-300 transition-colors duration-300 group-hover:text-blue-600">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="mt-6 text-lg font-semibold tracking-tight text-slate-900">
                  {s.title}
                </h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-900 transition-colors duration-300 group-hover:text-blue-600">
                  Explore {s.short}
                  <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
